import MicroModal from 'micromodal';

export namespace LeadConsentCollection {
	
	let setupLeadModal = () => {
		if (window.location.search == '?redirect=true') {
			(<HTMLInputElement>document.getElementById("NewsLetter")).checked = true;
			(<HTMLInputElement>document.getElementById("leadSubmitBtn")).disabled = false;
		}
		let links = document.querySelectorAll('.js-lead-consent');

		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				if (document.getElementsByTagName('hosted-ds-webform-confirmation').length < 1) {

					MicroModal.show('modal-lead-consent', {
						onShow: function () {
							//let leadConsentBtn = document.getElementById('ModalLeadConsentSubmit');
							//if (leadConsentBtn) {
							//	leadConsentBtn.blur();
							//}
						},
						onClose: function () {
							if (document.getElementsByTagName('cm-hosted-ds-webform-confirmation').length > 0) {
								(<HTMLInputElement>document.getElementById("leadSubmitBtn")).disabled = false;
							}
							let leadBtn = document.getElementById('leadSubmitBtn');
							if (leadBtn) {
								leadBtn.blur();
							}
						}						
					});
				}
				else if (document.getElementsByTagName('cm-hosted-ds-webform-confirmation').length > 0){
					var submitBtn = <HTMLInputElement>document.getElementById('leadSubmitBtn');
					submitBtn.disabled = false;
				}
				//(<HTMLInputElement>document.getElementById("nlSubscribe")).checked = false;
				//e.preventDefault();
				// if the consent is saved successfully then enable the Submit button on the Lead form.

				//var checkBox = <HTMLInputElement> document.getElementById('nlSubscribe');
				//var submitBtn = <HTMLInputElement> document.getElementById('nlSubscribeBtn');
				//if (checkBox.checked == true) {
				//	submitBtn.disabled = false;
				//} 
			});
		});
	}
	
	export const init = () => {
		setupLeadModal();
		
	}
}


document.addEventListener('DOMContentLoaded', LeadConsentCollection.init);
